import { Action, createReducer, on } from '@ngrx/store';
import { registerFlyout, showFlyout, hideFlyout, deRegisterFlyout } from './flyout.actions';
import { FlyoutState } from './flyout.state';

export const flyoutFeatureKey = 'flyouts';

export const initialState: FlyoutState = {
    flyouts: {}
};

const FlyoutReducer = createReducer(
    initialState,

    on(
        registerFlyout,
        (state, action): FlyoutState => ({
            ...state,
            flyouts: { ...state.flyouts, [action.id]: false }
        })
    ),
    on(deRegisterFlyout, (state, action): FlyoutState => {
        const { [action.id]: value, ...withoutFlyoutId } = state.flyouts;
        return {
            ...state,
            flyouts: withoutFlyoutId
        };
    }),
    on(
        showFlyout,
        (state, action): FlyoutState => ({
            ...state,
            flyouts: { ...state.flyouts, [action.id]: true }
        })
    ),
    on(
        hideFlyout,
        (state, action): FlyoutState => ({
            ...state,
            flyouts: { ...state.flyouts, [action.id]: false }
        })
    )
);

export const flyoutReducer = (state: FlyoutState | undefined, action: Action) => {
    return FlyoutReducer(state, action);
};
